module.exports = __webpack_public_path__ + "img/材料力学9_6.3a9794a5.jpg";